import { apiClient } from './api-client';

const TC_CONFIG_API = '/tc/config';

// ============ CONFIGURATION ============

export const getTransparencyConfig = async (companyKey) => {
  return await apiClient.get(`${TC_CONFIG_API}?companyKey=${companyKey}`);
};

export const updateGeneralSettings = async (companyKey, settings) => {
  return await apiClient.put(`${TC_CONFIG_API}/general?companyKey=${companyKey}`, settings);
};

export const updateFrameworkVisibility = async (companyKey, frameworks) => {
  return await apiClient.put(`${TC_CONFIG_API}/frameworks?companyKey=${companyKey}`, { frameworks });
};

export const updatePolicyVisibility = async (companyKey, policies) => {
  return await apiClient.put(`${TC_CONFIG_API}/policies?companyKey=${companyKey}`, { policies });
};

export const updateAccessControl = async (companyKey, settings) => {
  return await apiClient.put(`${TC_CONFIG_API}/access?companyKey=${companyKey}`, settings);
};

// ============ TOKEN MANAGEMENT ============

export const listTokens = async (companyKey) => {
  return await apiClient.get(`${TC_CONFIG_API}/tokens?companyKey=${companyKey}`);
};

export const createToken = async (companyKey, recipientEmail, recipientName, expirationHours) => {
  return await apiClient.post(`${TC_CONFIG_API}/tokens?companyKey=${companyKey}`, {
    recipientEmail,
    recipientName,
    expirationHours,
  });
};

export const revokeToken = async (companyKey, tokenId) => {
  return await apiClient.delete(`${TC_CONFIG_API}/tokens/${tokenId}?companyKey=${companyKey}`);
};

// ============ AUDIT LOGS ============

export const getAuditLogs = async (companyKey, params) => {
  const queryString = new URLSearchParams({ ...params, companyKey }).toString();
  return await apiClient.get(`${TC_CONFIG_API}/audit?${queryString}`);
};
